import { useIsEsnFromSession } from '@/store/useSessionUiStore'

/**
 * Indique si la team active est en mode ESN (menu Clients, etc.).
 * Données dérivées une fois depuis GET /auth/session (store sessionUi).
 * undefined = en cours de résolution — ne pas afficher les entrées requireEsn.
 */
export function useIsEsn(): boolean | undefined {
  return useIsEsnFromSession()
}
